import { useState, useEffect } from 'react';
import { getTimeRemaining } from '@cloudfruit-hunts/shared';

interface CountdownProps {
  targetDate?: string | null;
  compact?: boolean;
}

export function Countdown({ targetDate, compact }: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState(() =>
    targetDate ? getTimeRemaining(targetDate) : { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true }
  );

  useEffect(() => {
    if (!targetDate) return;

    const timer = setInterval(() => {
      setTimeLeft(getTimeRemaining(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (!targetDate) {
    return null;
  }

  if (timeLeft.isExpired) {
    return (
      <div className={compact ? 'text-accent font-medium' : 'text-xl font-bold text-accent'}>
        Started!
      </div>
    );
  }

  if (compact) {
    return (
      <div className="font-mono text-lg font-bold text-primary">
        {timeLeft.days > 0 && `${timeLeft.days}d `}
        {String(timeLeft.hours).padStart(2, '0')}:
        {String(timeLeft.minutes).padStart(2, '0')}:
        {String(timeLeft.seconds).padStart(2, '0')}
      </div>
    );
  }

  return (
    <div className="flex justify-center gap-4">
      <TimeUnit value={timeLeft.days} label="Days" />
      <TimeUnit value={timeLeft.hours} label="Hours" />
      <TimeUnit value={timeLeft.minutes} label="Minutes" />
      <TimeUnit value={timeLeft.seconds} label="Seconds" />
    </div>
  );
}

function TimeUnit({ value, label }: { value: number; label: string }) {
  return (
    <div className="text-center">
      <div className="bg-primary text-white text-3xl font-bold w-16 h-16 rounded-lg flex items-center justify-center">
        {String(value).padStart(2, '0')}
      </div>
      <div className="text-xs text-text-light mt-1">{label}</div>
    </div>
  );
}
